import React from 'react';
import { SignatureProps } from './SignatureProps';
import { WebSignatureView } from './web/WebSignatureView';

export function SignatureView(props: SignatureProps) {
  return <WebSignatureView {...props} />;
}
